import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    connect() {
        // Initialize menu as closed
        this.closeMenu()

        // Add transition properties to the menu
        this.menuTarget.classList.add("transition-all", "duration-100", "ease-in-out")
    }

    toggle() {
        if (this.menuTarget.classList.contains("translate-x-[-100%]")) {
            this.openMenu()
        } else {
            this.closeMenu()
        }
    }

    openMenu() {
        // First make it visible but translated off-screen
        this.menuTarget.classList.remove("hidden")
        this.menuTarget.classList.add("flex")

        // Force browser to process the display change before animation
        setTimeout(() => {
            this.menuTarget.classList.remove("translate-x-[-100%]", "opacity-0")
            this.menuTarget.classList.add("translate-x-0", "opacity-100")
        }, 10)

        // Prevent body scrolling when menu is open
        document.body.classList.add("overflow-hidden")
    }

    closeMenu() {
        // First make it invisible with transform
        this.menuTarget.classList.add("translate-x-[-100%]", "opacity-0")
        this.menuTarget.classList.remove("translate-x-0", "opacity-100")

        // Wait for animation to complete before hiding
        setTimeout(() => {
            this.menuTarget.classList.add("hidden")
            this.menuTarget.classList.remove("flex")
        }, 100)

        // Re-enable body scrolling when menu is closed
        document.body.classList.remove("overflow-hidden")
    }
}